// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-job-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
}

.create-job-container h1 {
  color: #1e3a5f;
  margin-bottom: 1.5rem;
}

.login-prompt {
  text-align: center;
  margin-top: 3rem;
  font-size: 1.1rem;
  color: #6b7280;
}

.login-prompt .link {
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
}

.create-job-form {
  display: flex;
  flex-direction: column;
}

.create-job-form label {
  font-weight: 600;
  margin-bottom: 0.3rem;
  margin-top: 1rem;
  color: #374151;
}

.create-job-form input,
.create-job-form textarea,
.create-job-form select {
  padding: 0.7rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
  font-family: inherit;
}

.create-job-form input:focus,
.create-job-form textarea:focus,
.create-job-form select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.type-toggle {
  display: flex;
  gap: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d1d5db;
}

.type-toggle button {
  flex: 1 1;
  padding: 0.7rem;
  border: none;
  background: white;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
}

.type-toggle button.active {
  background: #2563eb;
  color: white;
}

.location-fields {
  display: flex;
  flex-direction: column;
}

.location-fields label {
  font-weight: 600;
  margin-bottom: 0.3rem;
  margin-top: 0.8rem;
  color: #374151;
}

.location-fields input {
  padding: 0.7rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 1rem;
}

.form-error {
  background: #fef2f2;
  color: #dc2626;
  padding: 0.8rem 1rem;
  border-radius: 6px;
  border: 1px solid #fecaca;
}

.file-upload-btn {
  padding: 0.7rem 1rem;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  color: #6b7280;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
}

.file-upload-btn:hover {
  border-color: #2563eb;
  background: #eff6ff;
  color: #2563eb;
}

.geo-btn {
  margin-top: 0.8rem;
  padding: 0.6rem 1rem;
  background: #059669;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
}

.geo-btn:hover {
  background: #047857;
}

.geo-status {
  display: block;
  margin-top: 0.4rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.submit-btn {
  margin-top: 1.5rem;
  padding: 0.8rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
}

.submit-btn:hover {
  background: #1e40af;
}
`, "",{"version":3,"sources":["webpack://./src/CreateJob.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".create-job-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.create-job-container h1 {\n  color: #1e3a5f;\n  margin-bottom: 1.5rem;\n}\n\n.login-prompt {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n.login-prompt .link {\n  color: #2563eb;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.create-job-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.create-job-form label {\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n  margin-top: 1rem;\n  color: #374151;\n}\n\n.create-job-form input,\n.create-job-form textarea,\n.create-job-form select {\n  padding: 0.7rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-family: inherit;\n}\n\n.create-job-form input:focus,\n.create-job-form textarea:focus,\n.create-job-form select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);\n}\n\n.type-toggle {\n  display: flex;\n  gap: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n}\n\n.type-toggle button {\n  flex: 1;\n  padding: 0.7rem;\n  border: none;\n  background: white;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.type-toggle button.active {\n  background: #2563eb;\n  color: white;\n}\n\n.location-fields {\n  display: flex;\n  flex-direction: column;\n}\n\n.location-fields label {\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n  margin-top: 0.8rem;\n  color: #374151;\n}\n\n.location-fields input {\n  padding: 0.7rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.form-error {\n  background: #fef2f2;\n  color: #dc2626;\n  padding: 0.8rem 1rem;\n  border-radius: 6px;\n  border: 1px solid #fecaca;\n}\n\n.file-upload-btn {\n  padding: 0.7rem 1rem;\n  border: 2px dashed #d1d5db;\n  border-radius: 6px;\n  background: #f9fafb;\n  color: #6b7280;\n  font-size: 1rem;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.file-upload-btn:hover {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.geo-btn {\n  margin-top: 0.8rem;\n  padding: 0.6rem 1rem;\n  background: #059669;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.geo-btn:hover {\n  background: #047857;\n}\n\n.geo-status {\n  display: block;\n  margin-top: 0.4rem;\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.submit-btn {\n  margin-top: 1.5rem;\n  padding: 0.8rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #1e40af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
